module.exports = __webpack_public_path__ + "static/Branded Rock Canyon - Shooting Sports-43f4869311ef77c85c45020fbd8493ee.png";